import React from "react";
import SvgIcon from '@mui/material/SvgIcon';

export const IconClock = () => (
    <SvgIcon className="eventcard_icon" data-testid="clock-icon" aria-label="Clock Icon">
        <path d="M16.6 15.45C16.8485 15.1186 16.7814 14.6485 16.45 14.4L12.75 11.6251V7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7V12.0001C11.25 12.2362 11.3612 12.4585 11.55 12.6001L15.55 15.6C15.8814 15.8485 16.3515 15.7814 16.6 15.45Z"/>
        <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z"/>
    </SvgIcon>
)